import UserDTO from "@/models/UserDTO";
import {apiAxios} from "@/service/APIClient";

export const users = {
    me: async (): Promise<UserDTO> => {
        let resp = await apiAxios({
            url: `/users/me`,
            method: 'GET',
        })

        return resp.data as UserDTO
    },
    login: async (): Promise<UserDTO> => {
        let resp = await apiAxios({
            url: `/users/login`,
            method: 'POST',
        })

        return resp.data as UserDTO
    },
}